export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DetailHeader.vue?vue&type=template&id=8892161e&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/DetailHeader.vue?vue&type=template&id=8892161e&scoped=true&
// module id = 1570
// module chunks = 0